import { render, staticRenderFns } from "./BasePopupBtn.vue?vue&type=template&id=1770b2a4&scoped=true&"
import script from "./BasePopupBtn.vue?vue&type=script&lang=js&"
export * from "./BasePopupBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770b2a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
